import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadIdView } from '../../../../models';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Observable } from 'rxjs';
import {
  ShipmentLoadStatusChainLoad,
  ShipmentLoadStatusChainSetInitialState,
} from './shipment-load-status-chain.actions';
import { ShipmentLoadStatusChainState } from './shipment-load-status-chain.state';
import { ShipmentLoadStatusChainModel } from '../../models/shipment-load-status-chain.model';

@Injectable({ providedIn: 'root' })
export class ShipmentLoadStatusChainFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentLoadStatusChainState.getLoaded);
  statusChain$: Observable<ShipmentLoadStatusChainModel[]> = this.store.select(
    ShipmentLoadStatusChainState.getStatusChainView,
  );

  constructor(private store: Store) {}

  loadAll(identifier: LoadIdView): void {
    this.store.dispatch(new ShipmentLoadStatusChainLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentLoadStatusChainSetInitialState());
  }
}
